import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import BookingFlow from './BookingFlow';
import { trackBookingStarted } from '../utils/analytics';

const BookingModal = ({ isOpen, onClose }) => {
  // Track booking started when modal opens
  useEffect(() => {
    if (isOpen) {
      trackBookingStarted();
    }
  }, [isOpen]);

  const handleSuccess = () => {
    // Close shortly after success (toast is shown by BookingFlow)
    setTimeout(() => onClose(), 2000);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto bg-gray-900 border-gray-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-3xl font-black">
            <span className="bg-gradient-to-r from-red-500 to-yellow-400 bg-clip-text text-transparent">
              Book time
            </span>
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            Velg dato, tidspunkt og fyll inn dine detaljer
          </DialogDescription>
        </DialogHeader>

        <BookingFlow mode="modal" active={isOpen} onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
